import { configureStore, combineReducers } from "@reduxjs/toolkit";

/* AUTH */
import authReducer from "../auth/authSlice";

/* ADMIN */
import studentReducer from "./admin/student.slice";
import userAccountsReducer from "./admin/userAccounts.slice";
import feesReducer from "./admin/fees.slice";
import tournamentParticipantsReducer from "./admin/tournamentParticipants.slice";
import tournamentsReducer from "./admin/tournaments.slice";
import profitLossReducer from "./admin/profitLoss.slice";

/* ADMIN DOMAIN */
const adminReducer = combineReducers({
  students: studentReducer,
  userAccounts: userAccountsReducer, // ✅ Added
  fees: feesReducer,
  tournamentParticipants: tournamentParticipantsReducer,
  tournaments: tournamentsReducer,
  profitLoss: profitLossReducer, // ✅ ADD THIS
});

/* ROOT */
const rootReducer = combineReducers({
  auth: authReducer,
  admin: adminReducer,
});

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
